import { render, staticRenderFns } from "./UiGramIcon.vue?vue&type=template&id=77ffd522"
import script from "./UiGramIcon.vue?vue&type=script&lang=js"
export * from "./UiGramIcon.vue?vue&type=script&lang=js"
import style0 from "./UiGramIcon.vue?vue&type=style&index=0&id=77ffd522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports